import React from "react";
import { Box } from "@chakra-ui/react";

const HomeCard7 = () => {
  return (
    <Box
      w="100%"
      m="auto"
      bgColor="#000042"
      color="whiteAlpha.900"
      pt={9}
      pl={9}
    >
      <Box fontSize="35px" w="97%" margin="auto">
        Buy The Best Eyewear From Lenskart
      </Box>
      <br />
      <Box fontSize="15px" w="97%" margin="auto" pb="5" textAlign="justify">
        <Box w="95%">
          Lenskart Is The Leading E-Commerce Portal For Eyewear In India. It Has
          Revolutionised The Eyewear Industry In The Country With Its
          Omni-Channel Approach. From An Ever-Growing Number Of Offline Stores
          Across Major Cities In The Country To Innovative Integration Of
          Technology While Purchasing Online, Lenskart Caters To Every Customer
          With Several Deals And Offers.
        </Box>
        <br />
        <Box w="95%" textAlign="justify">
          A One-Stop Online Solution For Purchasing Eyewear And Its Accessories,
          Lenskart Delivers Them Right At Your Doorstep With Convenient Methods
          Of Payment. Sunglasses As Well As Eyeglasses Are Available For Men And
          Women In A Diverse Array Of Styles And Trendy Colours. If You Want To
          Try Out Contact Lenses, Pick The Ones Of Your Choice From The
          Extensive Variety Of Coloured Contact Lenses From Our Online Store.
        </Box>
      </Box>
    </Box>
  );
};

export default HomeCard7;
